import { z } from "zod";

const PAGE_SIZE = 10;

// Keep the members in sync with `AssetTypeSortBy` in ../../domain/models --
// the only three columns the real API can sort by.
export const assetTypeSortBySchema = z.enum(["nameEn", "nameAr", "createdAt"]);

export const assetTypesSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
  sort: z.enum(["asc", "desc"]).optional(),
  sortBy: assetTypeSortBySchema.optional(),
  search: z.string().trim().min(1).optional(),
});

export type AssetTypesSearch = z.infer<typeof assetTypesSearchSchema>;

// PROVISIONAL: mirrors GET /accounts/archived's convention (companies'
// archived list) -- sorts only by archive date, from/toArchivedAt set
// together. Adjust once the real archived asset types endpoint is confirmed.
export const archivedAssetTypesSearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
    sort: z.enum(["asc", "desc"]).optional(),
    search: z.string().trim().min(1).optional(),
    fromArchivedAt: z.string().datetime().optional(),
    toArchivedAt: z.string().datetime().optional(),
  })
  .refine(
    (search) =>
      (search.fromArchivedAt === undefined) ===
      (search.toArchivedAt === undefined),
  );

export type ArchivedAssetTypesSearch = z.infer<
  typeof archivedAssetTypesSearchSchema
>;
